export default "__VITE_ASSET__DPYpAxDw__"